module.exports = "<footer class=\"fixed-bottom pt-4\"><div class=\"d-flex justify-content-end py-3\" style=\"background: rgb(255, 255, 255);\"></div></footer>"